import { render, staticRenderFns } from "./ed-badge.vue?vue&type=template&id=377ec2ce&scoped=true&"
import script from "./ed-badge.ts?vue&type=script&lang=js&"
export * from "./ed-badge.ts?vue&type=script&lang=js&"
import style0 from "./ed-badge.scss?vue&type=style&index=0&id=377ec2ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377ec2ce",
  null
  
)

export default component.exports